// src/pages/LnDHome.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const LnDHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Immersive BookWorld");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const groupNames = [
    { label: "Immersive BookWorld", emoji: "📖" },
    { label: "Immersive Learning", emoji: "📚" },
    { label: "Competition Success", emoji: "🎯" },
    { label: "Learning Resources", emoji: "📚" },
    { label: "Guding-Obsering-Mentoring", emoji: "💡" },
    { label: "Study Engagement Insights", emoji: "📊" },
    { label: "Teachable", emoji: "🎓" },
    { label: "Task & Management", emoji: "📝" },
    { label: "Self Reflection", emoji: "🪞" },
    { label: "Recognition & Progress", emoji: "🏅" },
    { label: "Community & Social", emoji: "🤝" },
    { label: "Marketplace", emoji: "🛍️" },
    { label: "Income & Fun", emoji: "💰" },
    { label: "Authoring", emoji: "✍️" },

  ];

  const menuButtons1 = [
    // 💡 Immersive BookWorld
    { label: "BookWorld Concept", emoji: "📚", link: "/bookhelp", group: "Immersive BookWorld" },
    { label: "BookWorld", emoji: "📖", link: "/bookworld", group: "Immersive BookWorld" },
    { label: "Textbooks", emoji: "📘", link: "/bookworld", group: "Immersive BookWorld" },
    { label: "Supplementary Books", emoji: "📗", link: "/bookworld", group: "Immersive BookWorld" },    
    { label: "Periodicals", emoji: "📰", link: "/bookworld", group: "Immersive BookWorld" },    
    { label: "Corporate Books", emoji: "📙", link: "/bookworld", group: "Immersive BookWorld" },
    { label: "Professional Books", emoji: "📒", link: "/bookworld", group: "Immersive BookWorld" },        
    { label: "Book Collections", emoji: "📚", link: "/bookworld", group: "Immersive BookWorld" },
  
    // 💡 Immersive Learning
    { label: "BookShelf", emoji: "📖", link: "/bookshelf", group: "Immersive Learning" },
    { label: "Pre-School", emoji: "🧸", link: "/bookworld", group: "Immersive Learning" },
    { label: "School", emoji: "🏫", link: "/bookworld", group: "Immersive Learning" },
    { label: "College", emoji: "🎒", link: "/bookworld", group: "Immersive Learning" },
    { label: "University", emoji: "📘", link: "/bookworld", group: "Immersive Learning" },
    { label: "Coaching", emoji: "🧑‍🏫", link: "/bookworld", group: "Immersive Learning" },
    { label: "Corporate", emoji: "💼", link: "/bookworld", group: "Immersive Learning" },
    { label: "Government", emoji: "🏛️", link: "/bookworld", group: "Immersive Learning" },
    { label: "Skill Development", emoji: "🛠️", link: "/bookworld", group: "Immersive Learning" },
    { label: "YUVASolvers", emoji: "💡", link: "/bookworld", group: "Immersive Learning" },
    { label: "MSME", emoji: "🏭", link: "/bookworld", group: "Immersive Learning" },
    { label: "Women", emoji: "🌸", link: "/bookworld", group: "Immersive Learning" },
    { label: "Training & Workshops", emoji: "🎓", link: "/sheearns-trainingworkshop", group: "Immersive Learning" },
    { label: "Podcast", emoji: "🎙️", link: "/podcast-mylist", group: "Immersive Learning" },
    { label: "Certificates", emoji: "🏅", link: "/certificates", group: "Immersive Learning" },

    // 💡 Competition Success
    { label: "TestBook",       emoji: "📘", link: "/bookworld", group: "Competition Success" },
    { label: "Rankers",        emoji: "🏅", link: "/bookworld", group: "Competition Success" },
    { label: "VISTAAR",        emoji: "🌐", link: "/bookworld", group: "Competition Success" },
    { label: "JEE-NEET",       emoji: "📐", link: "/bookworld", group: "Competition Success" },
    { label: "Civil Services", emoji: "🏛️", link: "/bookworld", group: "Competition Success" },
    { label: "CAFE",           emoji: "📊", link: "/bookworld", group: "Competition Success" },

    // 💡 Learning Resources
    { label: "Learning Resources", emoji: "📚", link: "/learning-home", group: "Learning Resources" },
    { label: "Tonic", emoji: "📢", link: "/tonic-cafe", group: "Learning Resources" },
    
    // 💡 Guding-Obsering-Mentoring
    { label: "My Flyers On The Wall", emoji: "👀", link: "/bookshelf", group: "Guding-Obsering-Mentoring" },
    { label: "I Am Flying", emoji: "👁️", link: "/iamflying", group: "Guding-Obsering-Mentoring" },
    { label: "I Am Mentoring", emoji: "🧑‍🏫", link: "/mentoring", group: "Guding-Obsering-Mentoring" },
    { label: "My Mentors", emoji: "🤝", link: "/mymentors", group: "Guding-Obsering-Mentoring" },

    // 📊 Study Engagement Insights
    { label: "Quantity-based Comparisons",                 emoji: "📊", link: "", group: "Study Engagement Insights" },
    { label: "Reading Consistency or Fluctuations",        emoji: "⏱️", link: "", group: "Study Engagement Insights" },
    { label: "Contribution of Each Item to a Whole",       emoji: "🧮", link: "", group: "Study Engagement Insights" },
    { label: "Time of Day Analysis",                       emoji: "⏰", link: "", group: "Study Engagement Insights" },
    { label: "Habit Pattern Discovery",                    emoji: "🧩", link: "", group: "Study Engagement Insights" },
    { label: "KDE for Deep Insight",                       emoji: "📈", link: "", group: "Study Engagement Insights" },
    { label: "Median, Quartiles & Extremes",               emoji: "📏", link: "f", group: "Study Engagement Insights" },
    { label: "Total Volume and Individual Contributions",  emoji: "⚖️", link: "", group: "Study Engagement Insights" },
    { label: "Genre-Wise Preferences",                     emoji: "📚", link: "", group: "Study Engagement Insights" },
    { label: "Completion %, Daily/Weekly Targets",         emoji: "🎯", link: "", group: "Study Engagement Insights" },
    { label: "Compare with Peers",                         emoji: "👥", link: "", group: "Study Engagement Insights" },
    { label: "Reading Speed",                              emoji: "⚡", link: "", group: "Study Engagement Insights" },
    { label: "Sentiment Maps – Emotional Response",        emoji: "💬", link: "", group: "Study Engagement Insights" },
    { label: "Milestones and Streaks",                     emoji: "🏆", link: "", group: "Study Engagement Insights" },
    { label: "Speed, Consistency, Diversity in One View",  emoji: "🔎", link: "", group: "Study Engagement Insights" },

    // 💡 Teachable
    { label: "Success Kit", emoji: "🧰", link: "/startupkit", group: "Teachable" },
    { label: "Teachable Monthly", emoji: "🗓️", link: "/teachablebookworld", group: "Teachable" },
    { label: "Teacher Bookshelf", emoji: "📖", link: "/bookshelf", group: "Teachable" },
    { label: "Readfluencer", emoji: "👑", link: "/readfluencerdashboard", group: "Teachable" },
    { label: "Bloom's Room", emoji: "🌸", link: "/bloom-room", group: "Teachable" },
    { label: "Rubric Hub", emoji: "📊", link: "/rubric-grading-hub", group: "Teachable" },
    { label: "AI Evaluations", emoji: "🤖", link: "/aievaluation-list", group: "Teachable" },
    { label: "Predictive Learning", emoji: "🔮", link: "/pl-insights", group: "Teachable" },    
    { label: "Assignment Book", emoji: "📓", link: "/assignments-others", group: "Teachable" },
    { label: "Attendance", emoji: "📋", link: "/attendance", group: "Teachable" },
    { label: "CAFE Desk", emoji: "☕", link: "/cafe-bulletin", group: "Teachable" },
    { label: "Classroom Trackers", emoji: "📈", link: "/ce-tracker", group: "Teachable" },
    { label: "Clear The Doubt", emoji: "❓", link: "/my-concerns-list", group: "Teachable" },
    { label: "Dictation Drills Desk", emoji: "✏️", link: "/dictabook-home", group: "Teachable" },
    { label: "Feedback", emoji: "💬", link: "/student-feedback", group: "Teachable" },
    { label: "Flying On The Wall", emoji: "🦅", link: "/iamflying", group: "Teachable" },
    { label: "Handwritten Desk", emoji: "🖊️", link: "/touchbook-home", group: "Teachable" },
    { label: "Lesson Planner", emoji: "📅", link: "/lesson-planner", group: "Teachable" },
    { label: "Marks", emoji: "📉", link: "/marks", group: "Teachable" },
    { label: "Reports", emoji: "📄", link: "/student-reports", group: "Teachable" },
    { label: "Teacher's Calculators", emoji: "🧮", link: "/deepteach-calculators", group: "Teachable" },
    { label: "Tonic Bulletin", emoji: "📢", link: "/tonic-cafe", group: "Teachable" },
    { label: "Tonic Questions", emoji: "❓", link: "/tonic-cafe", group: "Teachable" },
    { label: "Teaching Notes", emoji: "📝", link: "/flipbook-home", group: "Teachable" },
    { label: "Topic RCA", emoji: "🔍", link: "/rcas/add", group: "Teachable" },
    { label: "Trainings & Workshops", emoji: "🎓", link: "/enroll/workshop", group: "Teachable" },
    { label: "Test Series Desk", emoji: "🧪", link: "/testseries-my", group: "Teachable" },
    { label: "Ladder", emoji: "🪜", link: "/msme-think5whysmaturity", group: "Teachable" },

    // 🗂️ TASK & MANAGEMENT
    { label: "Learner Daily", emoji: "📅", link: "/lnd-daily", group: "Task & Management" },
    { label: "Diary", emoji: "📔", link: "/mydiary-home", group: "Task & Management" },
    { label: "DeepThinking", emoji: "💡", link: "/fivewhys-analysis-home", group: "Task & Management" },
    { label: "Goal Board", emoji: "🎯", link: "/lnd-goalboard", group: "Task & Management" },
    { label: "Kanban", emoji: "📋", link: "/lnd-kanban", group: "Task & Management" },
    { label: "Digital Writing Paper", emoji: "📄", link: "/lnd-touchbookplain", group: "Task & Management" },
    { label: "Digital Writing Grid", emoji: "✍️", link: "/lnd-touchbookgrid", group: "Task & Management" },
    { label: "Digital Voice Writing", emoji: "🎙️", link: "/lnd-voicebook", group: "Task & Management" },
    { label: "Counselling Desk", emoji: "🛋️", link: "/counselling-list", group: "Task & Management" },

    // 🪞 SELF REFLECTION
    { label: "My Learner Card", emoji: "📘", link: "/digitalshakticard", group: "Self Reflection" },
    { label: "My Teacher Card", emoji: "🎓", link: "/digitalshakticard", group: "Self Reflection" },
    { label: "My Author Card", emoji: "✍️", link: "/digitalshakticard", group: "Self Reflection" },
    { label: "My Memories", emoji: "📸", link: "/memories-list", group: "Self Reflection" },
    { label: "Focus Timer", emoji: "⏱️", link: "/lnd-focustimerstart", group: "Self Reflection" },
    { label: "IKIGAI", emoji: "🧘‍♀️", link: "/myprofile-ikigai", group: "Self Reflection" },
    { label: "AI Counselling", emoji: "🤖", link: "/aicounselling", group: "Self Reflection" },
    { label: "Learner Journey", emoji: "👩‍🎓", link: "/lnd-motherhood", group: "Self Reflection" },
    { label: "My Jugaad / Hack", emoji: "💡", link: "/jugaad", group: "Self Reflection" },

    // 🏅 RECOGNITION & PROGRESS
    { label: "Students Rankings",      emoji: "🏆", link: "/sakshamshaktiscore", group: "Recognition & Progress" },
    { label: "Teachers Rankings",      emoji: "🎖️", link: "/sakshamshaktiscore", group: "Recognition & Progress" },
    { label: "Institutions Rankings",  emoji: "🏛️", link: "/sakshamshaktiscore", group: "Recognition & Progress" },
    { label: "Teachers Database",      emoji: "📚", link: "/teachabledb", group: "Teachable" },
    { label: "Self Applause",          emoji: "👏", link: "/self-applause", group: "Recognition & Progress" },
    { label: "I Was Appreciated",      emoji: "🌟", link: "/applause-for-me", group: "Recognition & Progress" },
    { label: "Edu Innovations",        emoji: "💡", link: "/lnd-innovationhub", group: "Recognition & Progress" },

    // 🤝 COMMUNITY & SOCIAL
    { label: "Educational Events", emoji: "📢", link: "/event-flow-home", group: "Community & Social" },
    { label: "Applause", emoji: "👏", link: "/applause-hub-home", group: "Community & Social" },
    { label: "Green Initiative", emoji: "🌱", link: "/coolearth-home", group: "Community & Social" },
    { label: "Responsible Indian", emoji: "🧑‍🤝‍🧑", link: "/rim", group: "Community & Social" },
    { label: "Immersive Presentation", emoji: "🎤", link: "/visualbrief-home", group: "Community & Social" },
    { label: "POV", emoji: "💬", link: "/povify-home", group: "Community & Social" },

    // 🛍️ Marketplace
    { label: "Books & Stationary", emoji: "👜", link: "/orderflow-home", group: "Marketplace" },
    { label: "Educational Products", emoji: "📦", link: "/orderflow-home", group: "Marketplace" },
    { label: "Mess Service", emoji: "🍱", link: "/bhojan", group: "Marketplace" },
    { label: "Gift", emoji: "🎁", link: "/giftify", group: "Marketplace" },
    { label: "RoomAnywhere", emoji: "🏠", link: "/roomanywhere", group: "Marketplace" },
    { label: "ThinkStylus", emoji: "🖊️", link: "/thinkstylus", group: "Marketplace" },
    { label: "MADSmania", emoji: "🔁", link: "/madsmania-home", group: "Marketplace" },
    { label: "I Have Product to Sell", emoji: "🙋‍♀️", link: "/mlmproductrequest/add", group: "Marketplace" },
    { label: "Window Shopping", emoji: "👀", link: "/twiworld", group: "Marketplace" },

    // 💰🎬 Income & Fun
    { label: "ValueShare",            emoji: "💵", link: "/orderflow-earning-estimator", group: "Income & Fun" },
    { label: "My Pocket Money", emoji: "🌱", link: "/myincomecredits", group: "Income & Fun" },
    { label: "My 2nd Income", emoji: "🌱", link: "/myincomecredits", group: "Income & Fun" },
    { label: "Shakti Digital Boutique", emoji: "🛍️", link: "/digiboutique", group: "Income & Fun" },
    { label: "Kharcho Jeeto",         emoji: "🎁", link: "/kharchojeeto", group: "Income & Fun" },
    { label: "Marksheet Contest",     emoji: "🏅", link: "/applause-marksheet-contest", group: "Income & Fun" },
    { label: "Rewarding Ads",         emoji: "📢", link: "/visigift-home", group: "Income & Fun" },
    { label: "Rewarding Videos",      emoji: "🎥", link: "/orderflow-spotbuy", group: "Income & Fun" },
    { label: "Education Funding",     emoji: "🎓", link: "/fundlanes", group: "Income & Fun" },
    { label: "eduTube",               emoji: "▶️", link: "/wtube", group: "Income & Fun" },
    { label: "Educational Games",     emoji: "🎮", link: "/lnd-games", group: "Income & Fun" },

    // ✍️ Authoring
    { label: "AuthorDesk",     emoji: "✍️", link: "/authordesk-home", group: "Authoring" },
    { label: "PublisherDesk",  emoji: "📚", link: "", group: "Authoring" },
    { label: "Curriculum and Textbook Bureaus",  emoji: "📚", link: "", group: "Authoring" },
    { label: "Institutions",   emoji: "🏫", link: "", group: "Authoring" },
    { label: "Coaching",       emoji: "🎯", link: "", group: "Authoring" },
    { label: "Government Officers",     emoji: "🏛️", link: "", group: "Authoring" },
  ];


  const filteredButtons = menuButtons1.filter((btn) => btn.group === activeTab);

  return (
    <div className="min-h-screen flex flex-col bg-black text-white font-sans">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-black border-b border-blue-400 px-4 py-2 flex items-center justify-between shadow-lg">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-yellow-200">📖✨LearnSkill Hub</div>
          <div className="text-xs lg:text-sm text-white">
            Evolving with Next-Gen Pedagogy and AI-Powered Learning for Everyone!
          </div>
        </div>

        {/* Desktop user controls */}
        <div className="hidden md:flex items-left gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs text-left text-white">{userName}</div>
              <button
                onClick={handleLogout}
                className="p-2 rounded-md bg-cyan-600 hover:bg-cyan-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-3 py-1 rounded-full border border-white-700 text-sm text-white hover:bg-white-900"
              >
                Login
              </button>
            </>
          )}
        </div>

        {/* Mobile hamburger */}
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 p-1 flex items-center justify-center text-xl text-white bg-white-500"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {/* Mobile menu content */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-cyan-500 border-b border-white-800 px-4 py-2 animate-fadeIn">
          {isLoggedIn ? (
            <div className="flex flex-row items-center justify-center gap-3">
              <span className="text-white font-medium text-xs whitespace-nowrap h-7">
                {userName}
              </span>
              <button
                onClick={handleLogout}
                className="rounded-md bg-cyan-600 hover:bg-cyan-700 w-7 h-7 flex items-center justify-center text-white"
                title="Logout"
              >
                ⏻
              </button>
            </div>
          ) : (
            <div className="flex flex-row items-center justify-center gap-6">
              <Link to="/login" className="text-white hover:text-yellow-300">
                Login
              </Link>
            </div>
          )}
        </div>
      )}

      {/* Top quick links */}
      <div className="bg-white-900/40 text-white text-sm lg:text-m py-2 mt-2 border-b border-blue-800">
        <div className="text-xs lg:text-sm mx-auto px-3 flex flex-wrap justify-center gap-2">
          <a href="/lnd-insights" className="hover:text-yellow-200">💭 About</a>
          <a href="/lnd-insights" className="hover:text-yellow-200">🧠 AI Counselling</a>
          <a href="/coolearth-home" className="hover:text-yellow-200">♻️ CoolEarth</a>
          <a href="/rim" className="hover:text-yellow-300">🌏 RIM</a>
          <a href="/lnd-updates" className="hover:text-yellow-200">📊 Updates</a>
        </div>
        <div className="mt-1 flex flex-wrap justify-center gap-3 text-sm text-cyan-500">
          <Link to="/think5whysistrusted" className="bg-cyan-600 text-yellow-200 hover:text-yellow-300 py-1 px-1 rounded-md text-xs lg:text-sm text-center">
            📝Register & Bring AI-Powered Pedagogy to Your Institution
          </Link>        
        </div>
        {/* <div className="mt-3 flex flex-wrap justify-center gap-3 text-sm text-blue-500">
          <Link to="/think5whysistrusted" className="text-yellow-200 hover:text-yellow-300 text-xs lg:text-sm">
            🔒 Trusted & Secure Platform – ISO 9001 / 27001, SOC-2 Certified
          </Link>        
        </div> */}
      </div>

      {/* Tabs */}
      <div className="mt-1 mb-1 px-3 py-1 border-b border-blue-800">
        <div className="grid grid-cols-3 lg:grid-cols-6 gap-1 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => setActiveTab(group.label)}
              className={`flex flex-col items-center justify-center w-full px-1 py-1 rounded-md text-xs lg:text-m font-medium transition ${
                activeTab === group.label
                  ? "bg-cyan-800 text-yellow-200 shadow-md"
                  : "bg-cyan-700 text-white hover:bg-cyan-800"
              }`}
            >
              <span className="text-lg lg:text-xl">{group.emoji}</span>
              <span className="mt-1 text-xs lg:text-m text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Main grid */}
      <main className="flex-grow mx-auto px-3 py-2 w-full justify-center items-center text-center">
        <div className="grid grid-cols-3 lg:grid-cols-6 gap-1 place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 lg:col-span-6 text-center text-white">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-1.5 py-1 rounded-md text-xs lg:text-m font-medium transition bg-transparent hover:bg-white-700 hover:text-yellow-200 text-white break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-lg lg:text-xl">{btn.emoji}</span>
                <span className="mt-1 text-xs lg:text-m">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main>

      <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs lg:text-sm text-yellow-200">
            © 2025 Think5Whys Global DeepTech Solutions. All rights reserved.
          </div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-blue-700">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-blue-700">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-blue-700">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-blue-700">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );

};

export default LnDHome;
